import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c8bcec6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "uppercase text-xl font-semibold mb-4" }, " Before you proceed... ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-80 text-xl mb-6" }, " Please read and agree to our Terms of Use: ", -1))
const _hoisted_4 = { class: "rounded-xl bg-white bg-opacity-5 border border-white border-opacity-20" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fade-overlay" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/terms",
  target: "_blank",
  class: "underline"
}, "Terms of Use.", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/privacy-policy",
  target: "_blank",
  class: "underline"
}, " Privacy Policy. ", -1))
const _hoisted_9 = { class: "h-5 ml-2 text-red-400" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_terms = _resolveComponent("terms")!
  const _component_n_checkbox = _resolveComponent("n-checkbox")!
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _ctx.showTermsModal && !_ctx.hideModal
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_n_card, { class: "terms-card max-w-xl rounded-xl" }, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_terms, {
                  id: "terms",
                  class: "p-4 max-h-[500px] overflow-y-scroll"
                })
              ])
            ]),
            _createVNode(_component_n_checkbox, {
              checked: _ctx.checkbox1,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkbox1) = $event)),
              class: "mt-6"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" I confirm that I have read, understand, and agree to the "),
                _hoisted_7
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_n_checkbox, {
              checked: _ctx.checkbox2,
              "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkbox2) = $event)),
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" I confirm that I have read and understand the "),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_component_nomad_button, {
              class: "w-full uppercase mt-6 bg-[#4496ef] h-11 flex justify-center",
              onClick: _ctx.agree
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Agree and continue ")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createElementVNode("div", _hoisted_9, [
              (_ctx.alert)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.alert), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}